import type { LineageRow } from '../../datagovernance/framework';

type Props = { items?: LineageRow[] };

export function DataLineagePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.flow} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{item.flow}</p>
          <div className="mt-2 flex items-center gap-2 text-xs text-slate-500">
            <span className="rounded bg-slate-100 px-2 py-0.5 dark:bg-slate-800">{item.source}</span>
            <span>→</span>
            <span className="rounded bg-slate-100 px-2 py-0.5 dark:bg-slate-800">{item.target}</span>
            <span className="ml-auto rounded-full bg-emerald-50 px-2 py-0.5 font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
              {item.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
